import React, { useEffect, useState, useRef, Fragment } from "react"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import { HiOutlineExclamationTriangle } from "react-icons/hi2"
import { Trans, useTranslation } from "react-i18next"
import clsx from "clsx"

import { hasFullAccess, moment, thousandSeparator } from "utils"
import { Modal, Button } from "components"
import { getServiceOwnerWallet, topupPaymentServiceOwner } from "services"
import classes from "./SystemDeactivationWarningModal.module.scss"

const SystemDeactivationWarningModal = () => {
  const [t, i18n] = useTranslation()

  const { isDeactivationWarningSet, deactivationWarningDate } =
    useSelector(state =>
      state.contractDeactivationStatus
    )

  const serviceTypeName =
    useSelector(state =>
      state.systemSettings.serviceTypeName
    )

  const [sending, setSending] = useState(false)
  const [serviceOwnerWallet, setServiceOwnerWallet] = useState(null)
  const [showDeactivationWarningModal, setShowDeactivationWarningModal] = useState(false)

  const unmount = useRef(false)

  const handleTopup = async () => {
    setSending(true)

    const minTopup = 10000

    const debt =
      Math.max(
        Math.abs(
          Math.round((serviceOwnerWallet.balance / 1000)) * 1000
        ),
        minTopup
      )

    try {
      const { gatewayUrl } =
        await topupPaymentServiceOwner({
          type: "zarinpal",
          amount: debt
        })

      window.location.href = gatewayUrl
    } catch (err) {
      console.log(err)

      if (unmount.current) return

      setSending(false)

      toast.error(t("عملیات_انجام_نشد"))
    }
  }

  const handleEnter = async () => {
    if (!hasFullAccess()) return

    if (serviceOwnerWallet !== null) return

    try {
      const response =
        await getServiceOwnerWallet()

      if (unmount.current) return

      setServiceOwnerWallet({ ...response })
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true
    }
  }, [])

  if (!isDeactivationWarningSet) return null

  const currentMoment = moment()

  const expirationDate =
    moment(deactivationWarningDate)

  expirationDate.add(3, "days")

  const daysToExpire =
    expirationDate.diff(currentMoment, "days")

  const dir = i18n.dir(i18n.language)

  const isLtr = dir === "ltr"

  return (
    <Fragment>
      <button
        onClick={() => setShowDeactivationWarningModal(true)}
        className={clsx(
          classes["float-button"],
          isLtr && classes["float-button-ltr"],
          serviceTypeName === "restaurant" && classes["offset"]
        )}
      >
        <HiOutlineExclamationTriangle
          size={30}
        />
      </button>

      <Modal
        onEnter={handleEnter}
        show={showDeactivationWarningModal}
        onHide={() => setShowDeactivationWarningModal(false)}
        centered
      >
        <div className={classes["container"]}>
          <div className={classes["title"]}>
            {t("بدهی سرویس شما از حد مجاز بیشتر شده است!")}
          </div>

          <div className={classes["subtitle"]}>
            <Trans i18nKey="مهلت_پرداخت_بدهی_daysToExpire_روز_دیگر_می_باشد">
              مهلت پرداخت بدهی <b><u>{{ daysToExpire }}</u></b> روز دیگر می باشد.
            </Trans>

            <br />
            {t("پس از انقضای این مدت، دسترسی به امکانات سامانه محدود خواهد شد.")}
            <br />
            {t("لطفا جهت پرداخت اقدام نمایید.")}
          </div>

          {
            serviceOwnerWallet &&
            <Fragment>
              <div className={classes["debt"]}>
                {t("بدهی شما")}:{" "}
                <b>{thousandSeparator(Math.abs(serviceOwnerWallet.balance))}</b>
              </div>
            </Fragment>
          }

          <div className={classes["footer"]}>
            <Button
              color="danger"
              onClick={() => setShowDeactivationWarningModal(false)}
            >
              {t("بستن")}
            </Button>

            {
              serviceOwnerWallet &&
              <Button
                color="success"
                loading={sending}
                onClick={handleTopup}
                className={clsx(classes["button"], isLtr && classes["button-ltr"])}
              >
                {t("پرداخت")}
              </Button>
            }
          </div>
        </div>
      </Modal>
    </Fragment>
  )
}

export default SystemDeactivationWarningModal